<template>
    <div style="padding: 16px; background-color: #EAE6E1">

        <div style="max-width: 600px; margin: auto;">

            <img style="width:100%; border-radius: 5px 5px 0px 0px"
                 src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Femail_tq.PNG?alt=media&token=33a0dafb-26aa-4646-8264-1a239a6d6604"/>

            <!--title -->
            <div style="background:white; margin-bottom: 4px; padding: 16px; font-size: 24px;">
                <div v-if="mode_n === 0 ">
                    ביטול כרטיס - 123321
                </div>
                <div v-if="mode_n === 1 ">
                    קבלה לכרטיס - 123321
                </div>

            </div>

            <div style="background:white; margin-bottom: 4px; padding: 16px;">
                <div style="text-align: center" v-if="mode_n === 1">
                    <div style="background: orange; font-weight: bold; font-size: 20px; padding: 8px; display:inline-block; border-radius: 5px;">
                        <a style="text-decoration: blink; color: white;" href="https://api.rivhit.co.il/pdf/FileService.svc/GetDocument/303035596/3f269c35-dcd5-4a11-8cef-b2c7e9a2179a/true/02_000001">
                            לצפייה במסמך לחץ כאן
                        </a>
                    </div>
                </div>
            </div>

            <!-- more info-->
            <div style="background:white; margin-bottom: 4px; padding: 16px;">
                <div style="font-size: 32px; border-bottom: 2px solid #885ead; margin-bottom: 12px;">
                    <b>מידע נוסף</b>
                </div>
                <div>
                    <div style="overflow-x: auto">

                        <table style="border: 1px solid black;border-collapse: collapse; box-sizing: border-box; ">

                            <tr >
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>מספר הזמנה</td>
                                <td style="border: 1px solid black; padding: 4px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                            </tr>

                            <tr >
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>מספר מקומות</td>
                                <td style="border: 1px solid black; padding: 4px;">10</td>
                            </tr>
                            <tr >
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>מחיר</td>
                                <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                            </tr>
                            <tr >
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>סטטוס</td>
                                <td v-if="mode_n === 0" style="border: 1px solid black; padding: 4px; background: red">בוטל</td>
                                <td v-if="mode_n === 1" style="border: 1px solid black; padding: 4px; background: green">נסלק</td>
                            </tr>
                            <tr >
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>תאריך</td>
                                <td style="border: 1px solid black; padding: 4px;">1/1/2018 13:30*</td>
                            </tr>

                        </table>
                    </div>
                    <br>
                    <div style="direction: ltr; display: inline-block;"> <b>*Timezone:</b> GMT+0200</div>

                </div>


                <hr>

                <table style="width:100%;">
                    <tr>
                        <td>
                            <div style='font-weight: bold; font-size: 20px;text-decoration: underline; '> טרוול קווסט</div>
                            <div>dan@TravelAndQuest.com</div>
                            <div>אשרמן 1 יוסף תל אביב, ישראל</div>
                            <a href="https://TravelQuest.xyz">https://TravelQuest.xyz</a>
                        </td>
                        <td style="text-align: left">
                            <img style="width:90px; border-radius: 16px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);" src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Fapple-touch-icon-120x120.png?alt=media&token=ded9d127-7038-4b0d-8e4c-de571e6eabba"/>
                        </td>
                    </tr>
                </table>


            </div>

        </div>

    </div>
</template>

<script>
    import {ass_svg_map_c} from "../../assets/scripts/Ass_Files";

    export default {
        name: "v_EmailCancelTicket",
        data() {
            return {
                ass_svg_map_c   : ass_svg_map_c,
                mode_n          : 1

            }
        }
    }

</script>

<style scoped>
</style>